import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FullPageLoader } from "@/components/common";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <FullPageLoader label="Authenticating" />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <FullPageLoader label="Authenticating" />;
  if (!user) return <Navigate to="/login" replace />;
  if (!["admin", "staff"].includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
};
